/** Item type values from the API */
export const API_ITEM_TYPE = {
  FOOD: 'Gerecht',
  DRINK: 'Drankje',
} as const

/** Item type keys for menu item theme styles */
export const VARIANT_ITEM_TYPE = {
  DINNER: 'dinner',
  DRINKS: 'drinks',
} as const
